import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconScanVoice: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconScanVoice"><Path d="M5 19H9V21H3V15H5V19Z" fill="currentColor"/><Path d="M21 21H15V19H19V15H21V21Z" fill="currentColor"/><Path d="M11.2305 17H9.42969V7H11.2305V17Z" fill="currentColor"/><Path d="M17.9004 15.5H16.0996V8.5H17.9004V15.5Z" fill="currentColor"/><Path d="M7.90039 14H6.09961V10H7.90039V14Z" fill="currentColor"/><Path d="M14.5703 14H12.7695V10H14.5703V14Z" fill="currentColor"/><Path d="M9 5H5V9H3V3H9V5Z" fill="currentColor"/><Path d="M21 9H19V5H15V3H21V9Z" fill="currentColor"/></CentralIconBase>;
});

export default IconScanVoice;
